export enum UTMKeys {
  'utmCampaign' = 'utm_campaign',
  'utmContent' = 'utm_content',
  'utmMedium' = 'utm_medium',
  'utmSource' = 'utm_source',
  'utmTerm' = 'utm_term',
}
